import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { useEffect, useContext } from 'react';
import LoginSignup from './components/loginsignup/loginsignup'; 
import Home from './components/home/home';
import Menubar from './components/menubar/menubar';
import Venue from './components/venue/venue';
import Vendor from './components/vendor/vendor';
import Planningtools from './components/planningtools/planningtools';
import CategoryForm from './components/catagorymanagement/CategoryForm';
import FunctionForm from './components/functionmanagement/FunctionForm';
import VenueForm from './components/venuemanagement/VenueForm';
import VendorForm from './components/vendormanagement/VendorForm';
import Addcatagory from './components/addcatagory/addcatagory';
import TypesOfFunction from './components/typesoffunction/typesoffunction';
import Footer from './components/footer/footer';
import Anniversary from './components/Anniversary/Anniversary';
import Registration from './components/registration/registration';
import ProfilePage from './components/ProfilePage/ProfilePage';
import Gallery from './components/gallery/gallery';
import MyOrders from './components/MyOrders/MyOrders';
import AllOrders from './components/AllOrders/AllOrders';
import Invoice from './components/invoice/invoice';
import UserTracker from './components/UserTracker/UserTracker';
import About from './components/about/about';
import Terms from './components/terms/terms';
import Policy from './components/policy/policy';
import CashfreePayment from './v2/CashfreePayment';
import PaymentSuccess from './v2/PaymentSuccess';
import RefundPage from './v2/RefundPage';
import { AuthContext, AuthProvider } from './context/Authcontext';

// ✅ ScrollToTop Component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
// Separate layout logic here
function AppContent() {
  const location = useLocation();
  const { user } = useContext(AuthContext); // Access user from context
  const showMenubar = location.pathname !== '/login';
  const showFooter = location.pathname !== '/login';

  return (
    <div className="app-wrapper">
      <ScrollToTop />
      {/* <UserTracker user={user} /> */}
      {showMenubar && <Menubar />}

      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/loginsignup" element={<LoginSignup />} />
        
          <Route path="/venue" element={<Venue/>}/>
           <Route path="/vendor" element={<Vendor/>}/>
          <Route path="/planningtools" element={<Planningtools />} />
          <Route path="/typesoffunction" element={<TypesOfFunction />} /> 
          <Route path="/anniversary" element={<Anniversary/>}/>
          <Route path="/ProfilePage" element={<ProfilePage/>}/>
          <Route path="/gallery" element={<Gallery/>}/>

          <Route path="/about" element={<About/>}/>
          <Route path="/terms" element={<Terms/>}/>
          <Route path="/policy" element={<Policy/>}/>
          <Route path="/MyOrders" element={<MyOrders/>}/>


          
  


          {/* admin */}
          <Route path="/CategoryForm" element={<CategoryForm />} />
          <Route path="/FunctionForm" element={<FunctionForm/>}/>
          <Route path="/VenueForm" element={<VenueForm/>}/>
          <Route path="/VendorForm" element={<VendorForm/>}/>
          <Route path="/addcatagory" element={<Addcatagory />} />
          <Route path="/registration" element={<Registration/>}/>
          <Route path="/AllOrders" element={<AllOrders/>}/>
          <Route path="/invoice" element={<Invoice />} />
 
               <Route path="/pay" element={<CashfreePayment />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/refund" element={<RefundPage />} />
  

        
        </Routes>
      </main>

      {showFooter && <Footer />} {/* ✅ Footer included outside Routes */}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
    <Router>
      <AppContent />
    </Router>
    </AuthProvider>
  );
}

export default App;
